import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from 'axios';
import { PrivateCompanyLeadData } from '../types/privateCompanyLead';

interface UseCreatePrivateCompanyLeadContractEquipmentCategoryProps {
  privateCompanyLeadId?: string
  onSuccess: (response: AxiosResponse<{ data: PrivateCompanyLeadData }>) => void
  onError: () => void
}

const useCreatePrivateCompanyLeadContractEquipmentCategory = ({ privateCompanyLeadId, onSuccess, onError }: UseCreatePrivateCompanyLeadContractEquipmentCategoryProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createPrivateCompanyLeadContractEquipmentCategory'],
    mutationFn: (data: { label: string, value: string }) => {
      const private_company_lead = {
        contract_attributes: {
          contract_equipment_categories_attributes: [
            {
              equipment_category_id: data.value,
              quantity: 1
            }
          ]
        }
      }

      return privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useCreatePrivateCompanyLeadContractEquipmentCategory
